import { connectHook } from 'app/common/components/connect-hook';
import CopyButton from './copy-button.js';
import { useCopyButton } from './copy-button-hook.js';

export default connectHook(CopyButton, useCopyButton);
